module.exports = __webpack_public_path__ + "static/media/HTML.b047f6ae.png";